/* ─── Page / step transitions ──────────────────────────────── */
export const pageVariants = {
  initial: { opacity: 0, y: 18, scale: 0.98 },
  animate: { opacity: 1, y: 0,  scale: 1    },
  exit:    { opacity: 0, y: -12, scale: 0.98 },
};

export const pageTransition = {
  duration: 0.38,
  ease: [0.32, 0.72, 0, 1],
};

export const exitTransition = {
  duration: 0.22,
  ease: [0.4, 0, 1, 1],
};

/* ─── Stagger container + children ─────────────────────────── */
export const staggerContainer = {
  initial: {},
  animate: {
    transition: { staggerChildren: 0.08, delayChildren: 0.04 },
  },
};

export const staggerItem = {
  initial: { opacity: 0, y: 16 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: [0.32, 0.72, 0, 1] },
  },
};

/* ─── Card entrance ─────────────────────────────────────────── */
export const cardEntrance = {
  initial: { opacity: 0, y: 28, scale: 0.97 },
  animate: {
    opacity: 1, y: 0, scale: 1,
    transition: { duration: 0.5, ease: [0.32, 0.72, 0, 1] },
  },
};

/* ─── Fade simple ───────────────────────────────────────────── */
export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.4 } },
  exit:    { opacity: 0, transition: { duration: 0.2 } },
};

/* ─── Button micro-interactions ─────────────────────────────── */
export const btnHover = {
  scale: 1.025,
  y: -1,
  transition: { duration: 0.18, ease: "easeOut" },
};
export const btnTap = { scale: 0.96, y: 0 };

export const btnHoverOutline = {
  scale: 1.03,
  y: -1,
  transition: { duration: 0.18 },
};

/* ─── Icon hover ────────────────────────────────────────────── */
export const iconHover = {
  scale: 1.2,
  rotate: 4,
  transition: { type: "spring", stiffness: 400, damping: 12 },
};

/* ─── Progress segment (spring) ─────────────────────────────── */
export const progressFill = {
  initial:  { scaleX: 0, originX: 0 },
  animate:  { scaleX: 1, originX: 0, transition: { type: "spring", stiffness: 180, damping: 22 } },
};
